import { computed, onMounted, onUnmounted, ref } from '@nuxtjs/composition-api';

const useResponsive = () => {
  const isMobileRef = ref(false);
  const isTabletRef = ref(false);

  function resizeHandler() {
    isMobileRef.value = window.matchMedia('(max-width: 767px)').matches;
    isTabletRef.value = window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
  }

  onMounted(() => {
    resizeHandler();
    window.removeEventListener('resize', resizeHandler);
    window.addEventListener('resize', resizeHandler);
  });
  onUnmounted(() => window.removeEventListener('resize', resizeHandler));

  const isMobile = computed(() => isMobileRef.value);
  const isTablet = computed(() => isTabletRef.value);

  return {
    isMobile,
    isTablet,
  };
};

export default useResponsive;
